import { LabelBadge } from 'components/Badge/LabelBadge'
import { DisplayCard } from 'components/DisplayCards/DisplayCard'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell, RightCell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import { Button, colors, Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import {
    FATIGUE_LEVEL_COLORS,
    FATIGUE_LEVEL_LABELS,
    IFatigueRow,
} from 'types/fatigue.interface'
import { MOCK_FATIGUE_ROWS } from './fatigueData'
import { STATUS_ACTION_WIDTH } from './Fatigue.styled'
import { ProgressFill, ProgressTrack } from '../../Operations.styled'

const formatRole = (item: IFatigueRow) =>
    `${item.role} - Site #${item.siteId} - Dept #${item.departmentId}`

const formatIndex = (item: IFatigueRow) => {
    const pct = Math.round(item.index * 100)
    return `Index ${item.index.toFixed(2)} - ${pct}%`
}

const columns: IHonestTableColumn<IFatigueRow>[] = [
    {
        id: 'status',
        header: 'Status',
        sticky: true,
        minWidth: '5rem',
        cell: (item) => {
            const color = FATIGUE_LEVEL_COLORS[item.level]
            return (
                <Flex column gap='0.5rem' center style={{ width: STATUS_ACTION_WIDTH, flexShrink: 0 }}>
                    <LabelBadge color={color} width={STATUS_ACTION_WIDTH}>
                        {FATIGUE_LEVEL_LABELS[item.level]}
                    </LabelBadge>
                    <LabelBadge
                        color={colors.orange}
                        backgroundColor={colors.paleOrange}
                        width={STATUS_ACTION_WIDTH}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {item.overrideActive ? 'Manage' : 'Override'}
                    </LabelBadge>
                </Flex>
            )
        },
    },
    {
        id: 'worker',
        header: 'Worker',
        fill: true,
        cell: (item) => (
            <Cell style={{ minHeight: 'auto' }}>
                <BodyText weight='600'>{item.name}</BodyText>
                <OtherText grey>{formatRole(item)}</OtherText>
            </Cell>
        ),
    },
    {
        id: 'index',
        header: 'Index',
        align: 'right',
        minWidth: '10rem',
        cell: (item) => {
            const color = FATIGUE_LEVEL_COLORS[item.level]
            const pct = Math.round(item.index * 100)
            return (
                <RightCell style={{ flexDirection: 'column', alignItems: 'flex-end', gap: '0.25rem' }}>
                    <ProgressTrack style={{ width: '8rem' }}>
                        <ProgressFill style={{ width: `${pct}%`, background: color }} />
                    </ProgressTrack>
                    <OtherText grey>{formatIndex(item)}</OtherText>
                </RightCell>
            )
        },
    },
    {
        id: 'hours',
        header: 'Hours',
        align: 'right',
        minWidth: '6rem',
        cell: (item) => (
            <RightCell>
                <BodyText>{item.hours7d}h / 7d</BodyText>
            </RightCell>
        ),
    },
    {
        id: 'days',
        header: 'Days',
        align: 'right',
        minWidth: '6rem',
        cell: (item) => (
            <RightCell>
                <BodyText>{item.consecutiveDays} consec.</BodyText>
            </RightCell>
        ),
    },
    {
        id: 'override',
        header: 'Override',
        align: 'right',
        minWidth: '8rem',
        cell: (item) => (
            <RightCell>
                {item.overrideActive ? (
                    <LabelBadge color={FATIGUE_LEVEL_COLORS.high}>Override active</LabelBadge>
                ) : (
                    <OtherText grey>No override</OtherText>
                )}
            </RightCell>
        ),
    },
]

export const Fatigue = () => {
    const navigate = useNavigate()

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between width='100%' mb='2rem'>
                    <H1WithBack title='Fatigue' arrow />
                    <Button orange onClick={() => navigate('rules')}>
                        Rules
                    </Button>
                </Flex>
                <Flex style={{ margin: '2rem 0' }} gap='1rem'>
                    <DisplayCard borderColor='#ff9900' value='10' label='Critical' />
                    <DisplayCard borderColor='#ff9900' value='10' label='High' />
                    <DisplayCard borderColor='#ff9900' value='10' label='Elevated' />
                    <DisplayCard borderColor='#ff9900' value='10' label='Low' />
                </Flex>

                <HonestTable columns={columns} data={MOCK_FATIGUE_ROWS} keyField='id' />
            </PageWrapper>
        </>
    )
}
